import React, { Component } from "react";
import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Tag,
  Switch,
  Collapse,
} from "antd";
import { connect } from "react-redux";
import {
  req_page_tqa_work_c_list,
  req_downloadfile_tqa_worker,
} from "../../api";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getNowAcademicYear } from "../../utils/dateUtil";
import DepartmentQuailtyCommom from "./department-quailty-common";
import DownloadTemplateModal from "./download-template-modal";

const { Panel } = Collapse;
class ManageWorkLevelCList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    switchStatus: true,
    domnloadFile: "",
    academicYear: getNowAcademicYear(new Date()),
    isC01Modal: false,
    isC02Modal: false,
    isC03Modal: false,
    isC04Modal: false,
    isC05Modal: false,
    isC06Modal: false,
    isC07Modal: false,
    isC08Modal: false,
    isC09Modal: false,
    isC10Modal: false,
    isC11Modal: false,
    isC12Modal: false,
    isC13Modal: false,
    isC14Modal: false,
    isC15Modal: false,
    isC16Modal: false,
    isC17Modal: false,
    isC18Modal: false,
    isC19Modal: false,
    isC20Modal: false,
    isC21Modal: false,
    isTemplateModal: false,

    modaldata: [
      {
        titlecode: "品保手冊表格代碼",
        titlename: "品保手冊表格名稱",
        coursemapcode: "課程地圖表格代碼",
        coursemapname: "課程地圖表格名稱",
        coursemapincode: "課程地圖表格內碼",
      },
      {
        titlecode: "C01",
        titlename: "系(學位學程)教育目標表",
        coursemapcode: "E01",
        coursemapname: "E01-校院系教育目標",
        coursemapincode: "EDUA",
      },
      {
        titlecode: "C02",
        titlename: "校與系(學位學程)教育目標關聯表",
        coursemapcode: "E02",
        coursemapname: "E02-校系教育目標關聯",
        coursemapincode: "EDUB",
      },
      {
        titlecode: "C03",
        titlename: "學院與系(學位學程)教育目標關聯表",
        coursemapcode: "E03",
        coursemapname: "E03-院系教育目標關聯",
        coursemapincode: "EDUC",
      },
      {
        titlecode: "C04",
        titlename: "系(學位學程)就業途徑表",
        coursemapcode: "A01",
        coursemapname: "A01-系所就業途徑表",
        coursemapincode: "A",
      },
      {
        titlecode: "C05",
        titlename: "系(學位學程)養成職能表",
        coursemapcode: "A02",
        coursemapname: "A02-校系教育目標關聯",
        coursemapincode: "B",
      },
      {
        titlecode: "C06",
        titlename: "系(學位學程)基本素養對應課程表",
        coursemapcode: "A03",
        coursemapname: "A03-基本素養對應課程表",
        coursemapincode: "C",
      },
      {
        titlecode: "C07",
        titlename: "系(學位學程)核心能力對應課程表",
        coursemapcode: "A04",
        coursemapname: "A04-核心能力對應課程表",
        coursemapincode: "D",
      },
      {
        titlecode: "C08",
        titlename: "系(學位學程)課程對每項基本素養貢獻度",
        coursemapcode: "A05",
        coursemapname: "A05-課程對每項基本素養貢獻度",
        coursemapincode: "G",
      },
      {
        titlecode: "C09",
        titlename: "系(學位學程)課程對每項核心能力貢獻度",
        coursemapcode: "A06",
        coursemapname: " A06-課程對每項核心能力貢獻度",
        coursemapincode: "O",
      },
      {
        titlecode: "C10",
        titlename: "系(學位學程)課程對就業途徑之基本素養貢獻度",
        coursemapcode: "A07",
        coursemapname: "A07-課程對就業途徑之基本素養貢獻度",
        coursemapincode: "F",
      },
      {
        titlecode: "C11",
        titlename: "系(學位學程)課程對就業途徑之核心能力貢獻度",
        coursemapcode: "A08",
        coursemapname: "A08-課程對就業途徑之核心能力貢獻度",
        coursemapincode: "N",
      },
      {
        titlecode: "C12",
        titlename: "系(學位學程)課程總表",
        coursemapcode: "A09",
        coursemapname: "A09-課程列表",
        coursemapincode: "E",
      },
      {
        titlecode: "C13",
        titlename: "系(學位學程)目標人才課程清單",
        coursemapcode: "A10",
        coursemapname: "A10-目標人才課程清單",
        coursemapincode: "H",
      },
      {
        titlecode: "C14",
        titlename: "系(學位學程)學習地圖之依目標人才呈現課程重要性",
        coursemapcode: "A11",
        coursemapname: "A11-學習地圖之依目標人才呈現課程重要性",
        coursemapincode: "MAPA",
      },
      {
        titlecode: "C15",
        titlename: "系(學位學程)學習地圖之依職能呈現課程重要性",
        coursemapcode: "A12",
        coursemapname: "A12-學習地圖之依職能呈現課程重要性",
        coursemapincode: "MAPB",
      },
      {
        titlecode: "C16",
        titlename: "系(學位學程)課程關聯性",
        coursemapcode: "A13",
        coursemapname: "A13-證照地圖-課程關聯性",
        coursemapincode: "M",
      },
      {
        titlecode: "C17",
        titlename: "系(學位學程)證照清單",
        coursemapcode: "A14",
        coursemapname: "A14-職涯進路-證照清單",
        coursemapincode: "I",
      },
      {
        titlecode: "C18",
        titlename: "系(學位學程)升學清單",
        coursemapcode: "A15",
        coursemapname: "A15-職涯進路-升學清單",
        coursemapincode: "K",
      },
      {
        titlecode: "C19",
        titlename: "系(學位學程)職業清單",
        coursemapcode: "A16",
        coursemapname: "A16-職涯進路-職業清單",
        coursemapincode: "P",
      },
      {
        titlecode: "C20",
        titlename: "系(學位學程)國考清單",
        coursemapcode: "A17",
        coursemapname: "A17-職涯進路-國考清單",
        coursemapincode: "J",
      },
      {
        titlecode: "C21",
        titlename: "本入學年度與上年度課程差異",
        coursemapcode: "D01",
        coursemapname: "D01-本入學年度與上年度課程差異",
        coursemapincode: "CF",
      },
    ],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_work_c_list(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_worker(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "品保作業人員清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "學院"; // 學院
        break;
      case "B": // 中心
        ans = "中心";
        break;
      case "C":
        ans = "學系"; // 學系
        break;
      case "D":
        ans = "碩班"; //碩班
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "gold";
    switch (column) {
      case "A":
        ans = "#87d068"; // 學院
        break;
      case "B": // 中心
        ans = "#108ee9";
        break;
      case "C": // 學系
        ans = "magenta";
        break;
      case "D":
        ans = "#f50"; // 碩班
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  handle_switch_change = (checked) => {
    // console.log(checked);
    this.setState({ switchStatus: checked }, () => {
      this.api_page_items(this.current);
    });
  };

  handle_show_ui_modal = (modal, item) => {
    console.log(item);
    switch (modal) {
      case "C01":
        this.setState({ isC01Modal: true, item });
        break;
      case "C02":
        this.setState({ isC02Modal: true, item });
        break;
      case "C03":
        this.setState({ isC03Modal: true, item });
        break;
      case "C04":
        this.setState({ isC04Modal: true, item });
        break;
      case "C05":
        this.setState({ isC05Modal: true, item });
        break;
      case "C06":
        this.setState({ isC06Modal: true, item });
        break;
      case "C07":
        this.setState({ isC07Modal: true, item });
        break;
      case "C08":
        this.setState({ isC08Modal: true, item });
        break;
      case "C09":
        this.setState({ isB09Modal: true, item });
        break;
      case "C10":
        this.setState({ isC10Modal: true, item });
        break;
      case "C11":
        this.setState({ isC11Modal: true, item });
        break;
      case "C12":
        this.setState({ isC12Modal: true, item });
        break;
      case "C13":
        this.setState({ isC13Modal: true, item });
        break;
      case "C14":
        this.setState({ isC14Modal: true, item });
        break;
      case "C15":
        this.setState({ isC15Modal: true, item });
        break;
      case "C16":
        this.setState({ isC16Modal: true, item });
        break;
      case "C17":
        this.setState({ isC17Modal: true, item });
        break;
      case "C18":
        this.setState({ isC18Modal: true, item });
        break;
      case "C19":
        this.setState({ isB19Modal: true, item });
        break;
      case "C20":
        this.setState({ isC20Modal: true, item });
        break;
      case "C21":
        this.setState({ isC21Modal: true, item });
        break;
      case "Template":
        this.setState({ isTemplateModal: true, item });
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    const academicYear = getNowAcademicYear(new Date());
    this.setState({ academicYear });
    this.columns = [
      {
        title: "分類",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { WorkTypeCode } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(WorkTypeCode)}>
                {this.style_switch_text_tag(WorkTypeCode)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "單位",
        dataIndex: "DepartmentName",
        width: 40,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "負責老師",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { AuthorName } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {AuthorName}</span>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 70,
        render: (item) => {
          const { switchStatus, modaldata } = this.state;
          const {
            C01Status,
            C02Status,
            C03Status,
            C04Status,
            C05Status,
            C06Status,
            C07Status,
            C08Status,
            C09Status,
            C10Status,
            C11Status,
            C12Status,
            C13Status,
            C14Status,
            C15Status,
            C16Status,
            C17Status,
            C18Status,
            C19Status,
            C20Status,
            C21Status,
            GidLearnMapMeta,
          } = item;
          return (
            <>
              {" "}
              <Collapse>
                <Panel header="課程地圖報表" key="1">
                  <Tooltip title={modaldata[1].titlename}>
                    <button
                      type="button"
                      className={
                        C01Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C01Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[1].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[1].titlename
                          : modaldata[1].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[2].titlename}>
                    <button
                      type="button"
                      className={
                        C02Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C02Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[2].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[2].titlename
                          : modaldata[2].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[3].titlename}>
                    <button
                      type="button"
                      className={
                        C03Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C03Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[3].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[3].titlename
                          : modaldata[3].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[4].titlename}>
                    <button
                      type="button"
                      className={
                        C04Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C04Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[4].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[4].titlename
                          : modaldata[4].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[5].titlename}>
                    <button
                      type="button"
                      className={
                        C05Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C05Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[5].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[5].titlename
                          : modaldata[5].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[6].titlename}>
                    <button
                      type="button"
                      className={
                        C06Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C06Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[6].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[6].titlename
                          : modaldata[6].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[7].titlename}>
                    <button
                      type="button"
                      className={
                        C07Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C07Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[7].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[7].titlename
                          : modaldata[7].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[8].titlename}>
                    <button
                      type="button"
                      className={
                        C08Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C08Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[8].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[8].titlename
                          : modaldata[8].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[9].titlename}>
                    <button
                      type="button"
                      className={
                        C09Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C09Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[9].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[9].titlename
                          : modaldata[9].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[10].titlename}>
                    <button
                      type="button"
                      className={
                        C10Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C10Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[10].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[10].titlename
                          : modaldata[10].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[11].titlename}>
                    <button
                      type="button"
                      className={
                        C11Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C11Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[11].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[11].titlename
                          : modaldata[11].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[12].titlename}>
                    <button
                      type="button"
                      className={
                        C12Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C12Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[12].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[12].titlename
                          : modaldata[12].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[13].titlename}>
                    <button
                      type="button"
                      className={
                        C13Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C13Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[13].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[13].titlename
                          : modaldata[13].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[14].titlename}>
                    <button
                      type="button"
                      className={
                        C14Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C14Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[14].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[14].titlename
                          : modaldata[14].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[15].titlename}>
                    <button
                      type="button"
                      className={
                        C15Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C15Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[15].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[15].titlename
                          : modaldata[15].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[16].titlename}>
                    <button
                      type="button"
                      className={
                        C16Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C16Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[16].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[16].titlename
                          : modaldata[16].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[17].titlename}>
                    <button
                      type="button"
                      className={
                        C17Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C17Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[17].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[17].titlename
                          : modaldata[17].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[18].titlename}>
                    <button
                      type="button"
                      className={
                        C18Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C18Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[18].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[18].titlename
                          : modaldata[18].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[19].titlename}>
                    <button
                      type="button"
                      className={
                        C19Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C19Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[19].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[19].titlename
                          : modaldata[19].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[20].titlename}>
                    <button
                      type="button"
                      className={
                        C20Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C20Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[20].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[20].titlename
                          : modaldata[20].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                  <Tooltip title={modaldata[21].titlename}>
                    <button
                      type="button"
                      className={
                        C21Status === "NONE"
                          ? "btn btn-outline-dark btn-sm"
                          : C21Status === "DONE"
                          ? "btn btn-outline-success btn-sm"
                          : "btn btn-outline-primary btn-sm"
                      }
                      onClick={() =>
                        this.handle_show_ui_modal(modaldata[21].titlecode, item)
                      }
                      disabled={GidLearnMapMeta === "UNSET" ? true : false}
                    >
                      <i className="fa fa-align-justify"></i>
                      <span style={{ marginLeft: "2px" }}>
                        {switchStatus
                          ? modaldata[21].titlename
                          : modaldata[21].titlecode}
                      </span>
                    </button>
                  </Tooltip>
                </Panel>
              </Collapse>
            </>
          );
        },
      },
    ];
  };
  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      academicYear,
      isC01Modal,
      isC02Modal,
      isC03Modal,
      isC04Modal,
      isC05Modal,
      isC06Modal,
      isC07Modal,
      isC08Modal,
      isC09Modal,
      isC10Modal,
      isC11Modal,
      isC12Modal,
      isC13Modal,
      isC14Modal,
      isC15Modal,
      isC16Modal,
      isC17Modal,
      isC18Modal,
      isC19Modal,
      isC20Modal,
      isC21Modal,
      isTemplateModal,
      modaldata,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="DepartmentName">單位</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </>
    );
    return (
      <Card title={title}>
        <Switch
          checkedChildren="代碼模式"
          unCheckedChildren="文字模式"
          onChange={this.handle_switch_change}
        />
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isTemplateModal}
          width={"60%"}
          onOk={() => {
            this.setState({ isTemplateModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isTemplateModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DownloadTemplateModal department={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC01Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC01Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC01Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[1].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC02Modal}
          width={"150px"}
          onOk={() => {
            this.setState({ isC02Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC02Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[2].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC03Modal}
          width={"150px"}
          onOk={() => {
            this.setState({ isC03Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC03Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[3].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC04Modal}
          width={"150px"}
          onOk={() => {
            this.setState({ isC04Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC04Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[4].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC05Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC05Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC05Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[5].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC06Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC06Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC06Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[6].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC07Modal}
          width={"150px"}
          onOk={() => {
            this.setState({ isC07Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC07Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[7].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC08Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC08Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC08Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[8].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC09Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC09Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC09Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[9].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC10Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC10Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC10Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[10].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC11Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC11Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC11Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[11].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC12Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC12Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC12Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[12].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC13Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC13Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC13Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[13].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC14Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC14Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC14Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[14].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC15Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC15Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC15Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[15].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC16Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC16Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC16Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[16].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC17Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC17Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC17Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[17].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC18Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC18Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC18Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[18].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC19Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC19Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC19Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[19].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC20Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC20Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC20Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[20].coursemapincode}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isC21Modal}
          width={"200px"}
          onOk={() => {
            this.setState({ isC21Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC21Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyCommom
            manual={item}
            doctype={modaldata[21].coursemapincode}
          />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManageWorkLevelCList);
